type RatingInput = string | number | null | undefined;

const toNumber = (value: RatingInput): number | null => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const buildAggregateRating = (
  averageScore: RatingInput,
  totalReviews: RatingInput,
) => {
  const score = toNumber(averageScore);
  const reviews = toNumber(totalReviews);
  if (score === null || reviews === null || reviews <= 0 || score <= 0) {
    return null;
  }
  return {
    '@type': 'AggregateRating',
    ratingValue: String(score),
    reviewCount: String(reviews),
    bestRating: '5',
    worstRating: '1',
  };
};
